<template>

	<div class="row my-auto mx-0 vertical-center section-row" >
		<span v-if="isDraggable" class="column-drag-handle grabbable"><i class="fontello icon-menu"></i></span>

		<div class="col-auto pr-0 header-title py-2"
			 @click.stop="onTitleClicked"
			:class="{clickable: isEditableVal}">
			<div class="my-auto">{{ programStep.name }}</div>
			<div v-if="programStep.goal" class="text-muted"><small>{{ 'Goal: ' + programStep.goal}}</small></div>
		</div>
		<div>
			<div v-if="isEditableVal" >
				<i class="fontello icon-pencil ml-3 edit button-circle" @click.stop="onTitleClicked"></i>
				<i class="fontello icon-trash ml-1 edit button-circle" @click.stop="onDeleteClicked"></i></div>
			<div class="layout-spacer"></div>
			<div v-if="isInCoachMode" class="mr-2">
				<!--			hey-->
			</div>
		</div>
		<div class="layout-spacer"></div>
		<div class="float-right text-right mr-2">
			<slot></slot>
		</div>
	</div>

</template>



<script>
	import BaseRow from "./BaseRow"

	export default {
        name: "CallRow",
		components: {},
		extends: BaseRow,

		methods:{
			onTitleClicked(){
				this.$emit("onTitleClicked")
			},
			onDeleteClicked(){
				this.$emit("onDeleteClicked")
			}
		},

    }
</script>

<style lang="scss">

	.section-row{
		.header-title{
			padding-left: 7px;
			max-width: 85%;
			overflow: hidden;
			line-height: 23px;
		}
	}

	//.section-row:hover .edit{
	//	opacity: 1;
	//}
	//
	//.section-row .edit{
	//	opacity: 0;
	//}


</style>
